<template>
  <v-row>
    <v-col cols="12">
      <v-textarea rows="2" label="about" v-model="data.about"></v-textarea>
    </v-col>
    <v-col cols="12">
      <p>Description</p>
      <text-editor v-model="data.description"></text-editor>
    </v-col>
    <v-col cols="12">
      <p>Products & services</p>
      <text-editor v-model="data.productsServices"></text-editor>
    </v-col>
    <v-col cols="12">
      <v-textarea rows="2" label="special" v-model="data.special"></v-textarea>
    </v-col>
    <v-col cols="12">
      <v-text-field label="offer" v-model="data.offer"></v-text-field>
    </v-col>

    <v-card flat width="100%">
      <v-card-title>
        Location
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="data.latitude"
              label="Latitude"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="data.longitude"
              label="Longitude"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat width="100%">
      <v-card-title>
        Links
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="data.links.facebook"
              label="Facebook"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="data.links.instagram"
              label="Instagram"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="data.links.youtube"
              label="Youtube"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-col cols="12">
      <select-multi-keywords v-model="data.keywords"> </select-multi-keywords>
    </v-col>
  </v-row>
</template>

<script>
import TextEditor from '../../../../components/TextEditor'
import SelectMultiKeywords from '../../../../components/SelectMultiKeywords'
export default {
  name: 'ListingForm',
  props: ['data'],
  components: {
    TextEditor,
    SelectMultiKeywords
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped></style>
